export const DAY_NAMES_TO_NUMBERS = {
    "domingo" : 0,
    "lunes" : 1,
    "martes" : 2,
    "miércoles" : 3,
    "jueves" : 4,
    "viernes" : 5,
    "sábado" : 6
}
